import { createApiRef } from '@backstage/core-plugin-api';
import { CasUserResponse } from './types';

/** @public */
export const UserPageApiRef = createApiRef<UserPageApi>({
  id: 'plugin.user-page.service',
});

/** @public */
export interface UserPageApi {
  getCasUserAndAppliances(url: string): Promise<CasUserResponse>;
}
